module.exports = __webpack_public_path__ + "static/media/KaTeX_Fraktur-Bold.e11e6bf0.ttf";